
    import './styles.scoped.css';
    export default {
  "dropdown-content-wrapper": "awsui_dropdown-content-wrapper_9duf6_4j07o_13",
  "awsui-motion-fade-in-dropdown": "awsui_awsui-motion-fade-in-dropdown_9duf6_4j07o_1",
  "refresh": "awsui_refresh_9duf6_4j07o_34",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_9duf6_4j07o_1",
  "root": "awsui_root_9duf6_4j07o_70",
  "interior": "awsui_interior_9duf6_4j07o_103",
  "dropdown": "awsui_dropdown_9duf6_4j07o_13",
  "use-portal": "awsui_use-portal_9duf6_4j07o_113",
  "is-empty": "awsui_is-empty_9duf6_4j07o_191",
  "dropdown-drop-up": "awsui_dropdown-drop-up_9duf6_4j07o_198",
  "with-limited-width": "awsui_with-limited-width_9duf6_4j07o_202",
  "dropdown-drop-left": "awsui_dropdown-drop-left_9duf6_4j07o_205",
  "dropdown-drop-right": "awsui_dropdown-drop-right_9duf6_4j07o_208",
  "occupy-entire-width": "awsui_occupy-entire-width_9duf6_4j07o_211",
  "use-flexible-width": "awsui_use-flexible-width_9duf6_4j07o_214",
  "hide-block-border": "awsui_hide-block-border_9duf6_4j07o_222",
  "open": "awsui_open_9duf6_4j07o_231",
  "nowrap": "awsui_nowrap_9duf6_4j07o_240",
  "dropdown-content": "awsui_dropdown-content_9duf6_4j07o_13",
  "stretch-trigger-height": "awsui_stretch-trigger-height_9duf6_4j07o_251"
};
  